/**
 * Shared Widget Import Map
 * 
 * Centralized location for all widget dynamic imports.
 * Used by both widgetRegistry (for lazy loading) and widgetPreloader (for background preloading).
 */

export const widgetImports = {
  // Banner Widgets
  BasicBanner: () => import('./banner/BasicBanner'),
  EssentialBanner: () => import('./banner/EssentialBanner'),
  ClassicBanner: () => import('./banner/ClassicBanner'),
  PrimeBanner: () => import('./banner/PrimeBanner'),
  
  // Navigation Widgets
  BasicNav: () => import('./nav').then(m => ({ default: m.BasicNav })),
  EssentialNav: () => import('./nav').then(m => ({ default: m.EssentialNav })),
  ClassicNav: () => import('./nav').then(m => ({ default: m.ClassicNav })),
  PrimeNav: () => import('./nav').then(m => ({ default: m.PrimeNav })),
  
  // Experience Widgets
  BasicExperienceCard: () => import('./experience').then(m => ({ default: m.BasicExperienceCard })),
  ClassicExperienceCard: () => import('./experience').then(m => ({ default: m.ClassicExperienceCard })),
  EssentialExperience: () => import('./experience').then(m => ({ default: m.EssentialExperience })),
  PrimeExperience: () => import('./experience').then(m => ({ default: m.PrimeExperience })),
  
  // Popular Items Widgets
  BasicPopularItems: () => import('./popular').then(m => ({ default: m.BasicPopularItems })),
  ClassicPopularItems: () => import('./popular').then(m => ({ default: m.ClassicPopularItems })),
  EssentialPopularItems: () => import('./popular').then(m => ({ default: m.EssentialPopularItems })),
  PrimePopularItems: () => import('./popular').then(m => ({ default: m.PrimePopularItems })),
  
  // Footer Widgets
  BasicFooter: () => import('./footer').then(m => ({ default: m.BasicFooter })),
  EssentialFooter: () => import('./footer').then(m => ({ default: m.EssentialFooter })),
  ClassicFooter: () => import('./footer').then(m => ({ default: m.ClassicFooter })),
  PrimeFooter: () => import('./footer').then(m => ({ default: m.PrimeFooter })),
  
  // Contact Form Widgets
  BasicContactForm: () => import('./contact').then(m => ({ default: m.BasicContactForm })),
  ClassicContactForm: () => import('./contact').then(m => ({ default: m.ClassicContactForm })),
  PrimeContactForm: () => import('./contact').then(m => ({ default: m.PrimeContactForm })),
  ModernContactForm: () => import('./contact').then(m => ({ default: m.ModernContactForm })),
  
  // Story Widgets
  BasicStory: () => import('./story').then(m => ({ default: m.BasicStory })),
  ClassicStory: () => import('./story').then(m => ({ default: m.ClassicStory })),
  PrimeStory: () => import('./story').then(m => ({ default: m.PrimeStory })),
  ModernStory: () => import('./story').then(m => ({ default: m.ModernStory })),
  
  // Blog Widgets
  BasicBlog: () => import('./blog').then(m => ({ default: m.BasicBlog })),
  ClassicBlog: () => import('./blog').then(m => ({ default: m.ClassicBlog })),
  PrimeBlog: () => import('./blog').then(m => ({ default: m.PrimeBlog })),
  ModernBlog: () => import('./blog').then(m => ({ default: m.ModernBlog })),
  
  // Event Widgets
  BasicEvents: () => import('./event').then(m => ({ default: m.BasicEvents })),
  ClassicEvents: () => import('./event').then(m => ({ default: m.ClassicEvents })),
  PrimeEvents: () => import('./event').then(m => ({ default: m.PrimeEvents })),
  ModernEvents: () => import('./event').then(m => ({ default: m.ModernEvents })),
  
  // Gallery Widgets
  BasicGallery: () => import('./gallery').then(m => ({ default: m.BasicGallery })),
  ClassicGallery: () => import('./gallery').then(m => ({ default: m.ClassicGallery })),
  PrimeGallery: () => import('./gallery').then(m => ({ default: m.PrimeGallery })),
  ModernGallery: () => import('./gallery').then(m => ({ default: m.ModernGallery })),
  
  // Layout Widgets
  LeftContentRightMediaLayout: () => import('./layout/LeftContentRightMedia'),
  RightContentLeftMediaLayout: () => import('./layout/RightContentLeftMedia'),
  SplitPromoCard: () => import('./layout/SplitPromo'),
  
  // Social Media Widgets
  BasicSocialFollow: () => import('./social/BasicSocialFollow'),
} as const;

export type WidgetImportKey = keyof typeof widgetImports;
